type LayoutShiftWithInputFlag = PerformanceEntry & {
  value: number;
  hadRecentInput: boolean;
};

export default defineNuxtPlugin(() => {
  if (!('PerformanceObserver' in window)) return;

  const SAMPLE_RATE = 0.1;
  if (Math.random() > SAMPLE_RATE) return;

  let clsValue = 0;

  const flushCLS = (path = window.location.pathname) => {
    if (!clsValue) return;
    const value = Number(clsValue.toFixed(4));
    const trackEvent = (
      window as Window & {
        umTrackEvent?: (event: string, value?: string) => void;
      }
    ).umTrackEvent;

    if (typeof trackEvent === 'function') {
      trackEvent('web-vitals-cls', `${path}:${value}`);
    }
    clsValue = 0;
  };

  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries() as LayoutShiftWithInputFlag[]) {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
      }
    }
  });

  observer.observe({ type: 'layout-shift', buffered: true });

  const onPageHide = () => flushCLS();
  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      flushCLS();
    }
  };

  window.addEventListener('pagehide', onPageHide, { passive: true });
  document.addEventListener('visibilitychange', onVisibilityChange, {
    passive: true,
  });

  const router = useRouter();
  router.afterEach((_to, from) => {
    flushCLS(from.fullPath || window.location.pathname);
  });
});
